<template>
    <div class="header-page">
        <div>{{title}}</div>
        <div class="subject" v-if="subject">{{ subject }}</div>
    </div>
</template>
<script>
export default {
    props: ['title', 'subject']
}
</script>
<style scoped>
.header-page {
    background: #333333;
    color: #fff;
    text-align: center;
    margin: 70px 40px 40px 40px;
    padding: 11px;
    border-radius: 30px;
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 36px;
}
.header-page .subject {
    font-size: 11px;
    font-weight: normal;
}
</style>
